import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Clique no botão abaixo para rever e confirmar as suas informações de pagamento.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Trabalhamos com Stripe para processar pagamentos. O Stripe é a plataforma de pagamento mais segura utilizada pelas maiores empresas do mundo.',
      form: {
        terms_acceptance: {
          label:
            'Ao prosseguir, aceita o nosso <FoodAmigosTerms>Acordo de Serviços</FoodAmigosTerms> e o <StripeTerms>Acordo de Conta Conectada Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'O Stripe marcou algumas informações do cliente como em falta ou inválidas. Corrija os seguintes erros clicando no botão «Abrir perfil Stripe»:',
        errors: 'Erros',
        awaiting_verification: 'A sua conta Stripe está a ser verificada',
        awaiting_verification_description:
          'Aguardamos que o Stripe conclua a verificação do seu negócio. Pode rever o seu perfil entretanto.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Trabalhamos com a Adyen para processar pagamentos. A Adyen é uma das plataformas de pagamento mais seguras, utilizada pelas maiores empresas do mundo.',
    },
  },
  labels: {
    verified: 'A sua conta {{paymentGateway}} está verificada',
    verified_description: 'A verificação do {{paymentGateway}} está concluída. Pode gerir o seu perfil se necessário.',
  },
  buttons: {
    proceed: 'Confirmar os meus dados de pagamento',
    copy_link: 'Copiar link',
  },
  toasts: {
    something_went_wrong: 'Ocorreu um erro, contacte o suporte técnico',
  },
};
